import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { callApi, getInlineLoader } from "../Helpers";
import OnePaymentRecord from "../ones/OnePaymentRecord";

export default function MyPayments() {

  const appContext = useContext(AppContext);

  const [ready, setReady] = useState(false);
  const [payments, setPayments] = useState([]);

  async function init() {
    setReady(false);
    await getPayments();
    setReady(true);
  }

  function getPayments() {
    return new Promise(async resolve => {
      await callApi("get-my-payments", {}).then((response) => {
        if (response.status === 1) {
          setPayments(response.data || []);
        } else {
          appContext.tellError(response.msg);
        }

        resolve(response);
      })
    })
  }

  useEffect(() => {
    init();
  }, [])

  if (ready) {
    return (
      <div
        className="mNoScrollBar"
        style={{
          width: "100%",
          height: "100%",
          overflow: "scroll",
          paddingTop: "20px",
          paddingBottom: "100px",
        }}
      >
        <div className="container">
          <h6 className="main-section-title">
            {
              appContext.language === "sw"
                ? "Malipo yangu"
                : "My payments"
            }
            <br />
            ({payments.length})
          </h6>

          {
            payments.map((item) => (
              <OnePaymentRecord
                data={item}
                key={item.uuid}
              />
            ))
          }

          {
            payments.length === 0
              ? <p className="text-muted">
                {
                  appContext.language === "sw"
                    ? "Hakuna malipo bado."
                    : "No payment records yet."
                }
              </p>
              : ""
          }
        </div>
      </div>
    )
  } else {
    return (
      <div
        className="mSupportLoading"
        style={{
          width: "100%",
          height: "100%",
        }}
      >
        {getInlineLoader()}
      </div>
    )
  }
}
